import Backbone from 'backbone'
import _ from 'lodash'
import orgGroupPermissionsGroupTemplate from './org-group-permissions-group.hbs'
import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'

/**
 * Panel for each of the OrganizationTemplatePermissions associated with a
 * given organization on the Admin > Groups > By Organization screen
 */
const OrgGroupTemplatePermissionsPanel = Backbone.View.extend({
	className: 'org-group-permissions-panel organization-template-permissions',

	/** @type OrganizationTemplatePermission */
	model: null,

	initialize (options) {
		this.options = options
	},

	render() {
		let html = `<ul class="list">`

		html += _(this.options.rollupTreeGroup.principals)
			.sortBy(p => {
				const principalLabel =
					this.principalLabel(p)?.toLowerCase()
				return getPrincipalSortKey(p, principalLabel)
			})
			.map(p => {
				if (p.type === 'group') {
					return this.renderGroup(p)
				} else if (p.type === 'user') {
					return this.renderUser(p)
				}
			})
			.join('')

		html += '</ul>'

		this.$el.empty().append(html)

		return this
	},

	renderGroup (p) {
		// First get the group definition with the generic settings
		let genericGroup = _.find(this.options.groups, g => g.groupId == p.id)

		// Now apply setting specific to this OrganizationTemplatePermission
		let group = _.extend({}, genericGroup,{
			// Group could be a "power users" group, but for the org
			// template, it could be something else like "view only"
			fullLabel: this.principalLabel(p, this.model.get('groupType')),
			// Cascade setting comes from the OrganizationTemplatePermission
			cascade: this.model.get('cascade'),
			organizationTemplateId: this.model.get('organizationTemplateId'),
			rollupTreeGroup: this.options.rollupTreeGroup
		})

		return orgGroupPermissionsGroupTemplate({
			panel: {
				cascadable: true,
				showCascadeButton: false
			},
			group
		})
	},

	renderUser (p) {
		return `<li class="user-item user">`
			// No escaping needed, see principalLabel()
			+ `<h3 class="user-label">`
			+ icon('user-avatar')
			+ `${this.principalLabel(p)}</h3>`
			+ `</li>`
	},

	principalLabel (principal, overrideGroupType) {
		// Note: already escaped in OrgGroupPermissionsForm.getPrincipalLabel()
		return this.options.principalLabelFunction(principal, overrideGroupType)
	},

	headerLabel () {
		let label = this.options.rollupTreeGroup.label
		let suffix = i18n
			.get('admin.group.permission.template.collapsible.header.suffix')
		return `<span class="text">${_.escape(label)} ${_.escape(suffix)}</span>
		    <span class="count">(${this.principalCount()})</span>`
	},

	principalCount () {
		return this.options.rollupTreeGroup.principals?.length
	},

	autoRemove: true
})

/**
 * Labels principals by type for sorting preferences, and then concatenates
 * the type key with the label
 * @param p - the principal to sort
 * @param principalLabel - the label for the principal determined by its type
 * @returns {string} - the sort key in the format A/B + principal label
 */
function getPrincipalSortKey(p, principalLabel) {
	const typeKey = p.type === 'user' ? 'A' : 'B'
	return typeKey + principalLabel
}

export default OrgGroupTemplatePermissionsPanel
export { getPrincipalSortKey }

OrgGroupTemplatePermissionsPanel.__filename__ = 'admin/principals/groups/org-group-template-permissions-panel.js'
